var exports = {
  "s": "Nav__9jtboE",
  "I": "Icon__lEhJty",
};

module.exports = exports;
